import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import {TBntIcon} from '@figma-icons/figma-icons';
import {BntFigmaIconComponent} from '@binotel-frontend/bnt-common-components';

@Component({
  selector: 'od-icon-button',
  template: `
    <button
      [attr.aria-label]="$computedAriaLabel()"
      [disabled]="disabled()"
      tabindex="0"
      type="button"
      class="icon-button"
    >
      <bnt-figma-icon [name]="name()" />
    </button>
  `,
  styleUrls: ['./icon-button.component.scss'],
  imports: [BntFigmaIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconButtonComponent {
  public readonly name = input.required<TBntIcon>();
  public readonly ariaLabel = input<string>('');
  public readonly disabled = input<boolean>(false);

  public readonly $computedAriaLabel = computed(
    () => `${this.ariaLabel()} icon button`
  );
}
